import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Edit = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 18"
      fill={fill}
      {...rest}
      width={Sizes[size]}
      height={Sizes[size]}
    >
      <g transform="translate(.411)">
        <g transform="translate(2.198 2.108)">
          <path
            d="M16.543 3.385L14.134.976a.6.6 0 0 0-.852 0L11.6 2.659l3.261 3.261 1.682-1.682a.6.6 0 0 0 0-.853z"
            transform="translate(-3.47 -.8)"
          />
          <path
            d="M8.079 4.4l-5.9 5.9a.6.6 0 0 0-.145.235l-1.2 3.613a.6.6 0 0 0 .571.793.594.594 0 0 0 .19-.031l3.613-1.2a.6.6 0 0 0 .235-.145l5.9-5.9z"
            transform="translate(-.801 -1.69)"
          />
        </g>
      </g>
    </svg>
  );
};

Edit.displayName = 'Edit';
